<div class="flex h-full flex-col">
  <!-- Toolbar with Building Blocks -->
  <app-partner-toolbar>
    <ng-container toolbarLeft>
      <app-toolbar-title [title]="title()" class="w-full sm:max-w-[250px]" />
    </ng-container>

    <ng-container toolbarRight>
      <!-- Desktop: Search visible -->
      <app-toolbar-search
        [(value)]="searchTerm"
        [placeholder]="'routing.SUB_ROUTE_PARTNERS.TOOLBAR.SEARCH_PLACEHOLDER' | t"
        class="hidden sm:block"
      />
      <app-bp-grouping-selector [value]="groupingCriteria()" (valueChange)="onGroupingChange($event)" />
      <!-- Desktop: Individual action buttons -->
      <div class="hidden items-center gap-1 sm:flex">
        <button
          mat-icon-button
          (click)="openFrequencyModal()"
          color="primary"
          [matTooltip]="'routing.SUB_ROUTE_PARTNERS.TOOLBAR.FREQUENCIES_TOOLTIP' | t"
        >
          <mat-icon svgIcon="heroicons_solid:calendar-days"></mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="openAppointmentModal()"
          color="primary"
          [matTooltip]="'routing.SUB_ROUTE_PARTNERS.TOOLBAR.APPOINTMENTS_TOOLTIP' | t"
        >
          <mat-icon svgIcon="heroicons_solid:clipboard-document-check"></mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="openMapModal()"
          color="primary"
          [matTooltip]="'routing.SUB_ROUTE_PARTNERS.TOOLBAR.MAP_TOOLTIP' | t"
        >
          <mat-icon svgIcon="heroicons_solid:map-pin"></mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="openBulkGpsUpdateModal()"
          color="primary"
          [disabled]="viewMode() === 'group'"
          [matTooltip]="
            viewMode() === 'group'
              ? ('routing.SUB_ROUTE_PARTNERS.TOOLBAR.BULK_GPS_DISABLED_TOOLTIP' | t)
              : ('routing.SUB_ROUTE_PARTNERS.TOOLBAR.BULK_GPS_TOOLTIP' | t)
          "
          *canPermissionsOnly="BUSINESS_PARTNER_PERMISSIONS.UPDATE"
        >
          <mat-icon>gps_fixed</mat-icon>
        </button>
        <app-toolbar-export-button
          (exportClick)="onExport()"
          [disabled]="viewMode() === 'group' || !(BUSINESS_PARTNER_PERMISSIONS.EXPORT | hasPermission)"
          [tooltip]="
            viewMode() === 'group'
              ? ('routing.SUB_ROUTE_PARTNERS.TOOLBAR.EXPORT_DISABLED_TOOLTIP' | t)
              : ('GENERAL.EXPORT' | t)
          "
        />
      </div>
      <!-- Mobile: Overflow menu -->
      <button mat-icon-button [matMenuTriggerFor]="mobileActionsMenu" class="sm:hidden">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #mobileActionsMenu="matMenu">
        <button mat-menu-item (click)="toggleMobileSearch()">
          <mat-icon>search</mat-icon>
          <span>{{ 'routing.SUB_ROUTE_PARTNERS.TOOLBAR.SEARCH_MENU_LABEL' | t }}</span>
        </button>
        <button mat-menu-item (click)="openFrequencyModal()">
          <mat-icon svgIcon="heroicons_solid:calendar-days"></mat-icon>
          <span>{{ 'routing.SUB_ROUTE_PARTNERS.TOOLBAR.FREQUENCIES_TOOLTIP' | t }}</span>
        </button>
        <button mat-menu-item (click)="openAppointmentModal()">
          <mat-icon svgIcon="heroicons_solid:clipboard-document-check"></mat-icon>
          <span>{{ 'routing.SUB_ROUTE_PARTNERS.TOOLBAR.APPOINTMENTS_TOOLTIP' | t }}</span>
        </button>
        <button mat-menu-item (click)="openMapModal()">
          <mat-icon svgIcon="heroicons_solid:map-pin"></mat-icon>
          <span>{{ 'routing.SUB_ROUTE_PARTNERS.TOOLBAR.MAP_TOOLTIP' | t }}</span>
        </button>
        <button
          mat-menu-item
          (click)="openBulkGpsUpdateModal()"
          [disabled]="viewMode() === 'group'"
          *canPermissionsOnly="BUSINESS_PARTNER_PERMISSIONS.UPDATE"
        >
          <mat-icon>gps_fixed</mat-icon>
          <span>{{ 'routing.SUB_ROUTE_PARTNERS.TOOLBAR.BULK_GPS_TOOLTIP' | t }}</span>
        </button>
        <button mat-menu-item (click)="onExport()" [disabled]="viewMode() === 'group' || !(BUSINESS_PARTNER_PERMISSIONS.EXPORT | hasPermission)">
          <mat-icon svgIcon="heroicons_outline:document-arrow-down"></mat-icon>
          <span>{{ 'GENERAL.EXPORT' | t }}</span>
        </button>
      </mat-menu>
    </ng-container>
  </app-partner-toolbar>

  <!-- Mobile: Expandable search -->
  @if (showMobileSearch()) {
    <div class="border-b border-gray-200 px-4 py-2 dark:border-gray-700 sm:hidden">
      <app-toolbar-search
        [(value)]="searchTerm"
        [placeholder]="'routing.SUB_ROUTE_PARTNERS.TOOLBAR.SEARCH_PLACEHOLDER' | t"
        class="w-full"
      />
    </div>
  }

  <!-- Content: List or Grouped view -->
  @switch (viewMode()) {
    @case ('list') {
      <app-assigned-partners-list class="min-h-0 flex-1" />
    }
    @case ('group') {
      <app-assigned-partners-grouped class="min-h-0 flex-1" />
    }
  }
</div>
